/**
 * 法语（fr）
 */

export default {
  // 支付
  common: {
    default: 'Défaut',
    delete: 'Effacer',
    cancel: 'Annuler',
    submit: 'Soumettre',
    inputContent: "Contenu d'entrée",
    selectContent: 'Select Content',
    pleaseEnter: "Entrez s'il vous plait",
    confirm: 'confirmer',
    Warning: 'Avertissement',
    success: 'Succès',
    next: 'Suivant'
  },
  payment: {
    payment: 'Paiement',
    availableBalance: 'Solde disponible',
    topUp: 'recharger',
    creditCard: 'Carte de crédit',
    settings: 'Les paramètres',
    transactions: 'Transactions',
    paymentMethods: 'méthodes de payement',
    type: 'Taper',
    orderNumber: 'Numéro de commande',
    amount: 'Montant',
    transactionTime: 'Heure de la transaction',
    allType: 'Tous les types',
    expenditure: 'Dépense',
    income: 'Revenu',
    balance: 'Équilibre',
    refund: 'Remboursement',
    sample: 'Échantillon',
    purchase: 'Acheter',
    orderGoods: 'Commander des marchandises',
    cardNo: 'numéro de carte',
    expireDate: "Date d'expiration",
    addCard: 'Ajouter une carte de crédit',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    export: 'Exportation',
    enterAmount: 'Veuillez saisir le montant',
    dropshipping: 'livraison directe',
    recharge: 'recharger',
    orderDeposit: 'dépôt de commande',
    orderBalance: 'solde de la commande',
    systemTopup: 'Système complet',
    giftCard: 'Carte cadeau'
  },
  // 地址
  address: {
    address: 'Adresse',
    editTheAddress: "Modifier l'adresse",
    setAsDefault: 'Définir par défaut',
    addAddress: "Ajoutez l'adresse",
    fullName: 'Nom et prénom',
    phoneNumber: 'Numéro de téléphone',
    streetAddressLine1: 'rue 1',
    streetAddressLine2: 'rue 2',
    city: 'Ville',
    state: 'État',
    provice: 'Province',
    region: 'Région',
    country: 'Pays',
    zipCode: 'Code postal',
    vat: 'T.V.A.',
    setAsDefaultAddress: 'Définir comme adresse par défaut',
    defaultAddress: 'Adresse par défaut',
    stateProviceRegion: 'État / province / région',
    deleteTip: 'Êtes-vous sûr de supprimer cette adresse ?'
  },
  // 店铺
  store: {
    store: 'Boutique',
    stores: 'magasins',
    allStores: 'Tous les magasins',
    storeTips: "Une fois votre boutique ajoutée, vous pouvez publier des dizaines de milliers d'articles tendance sur votre boutique en quelques clics seulement. KakaClo s'occupera de tout le reste pour vous une fois la commande passée sur votre boutique.",
    allowStoreBinding: 'Autoriser la liaison de magasin',
    connectANewStore: 'Connectez un nouveau magasin',
    authorized: 'Autorisé',
    unauthorized: 'Non autorisé',
    reauthorize: 'Autoriser à nouveau',
    storeSettings: 'Paramètres du magasin',
    removeStoreTitle: 'Êtes-vous sûr de vouloir supprimer ce magasin?',
    removeStoreTips: 'Si vous souhaitez simplement arrêter la synchronisation des données de la boutique avec notre plateforme et conserver les paramètres de votre boutique, vous pouvez désactiver la boutique au lieu de la supprimer.',
    removeStoreTips1: 'Une fois le magasin supprimé, les données suivantes associées au magasin seront également supprimées et ne pourront pas être récupérées :',
    listings: 'Listings',
    OrdersOfstore: 'Commandes du magasin.',
    removeTheStore: 'Supprimer le magasin',
    storeUrl: 'URL du magasin',
    openStoreMsg: 'Félicitations activation, vous obtiendrez la commande de votre magasin lié!',
    closeStoreAlert: 'Êtes-vous sûr de vouloir désactiver la boutique?',
    closeStoreTips: 'Vous ne pourrez plus recevoir de commandes une fois la boutique désactivée',
    closeStoreMsg: 'Vous avez fermé votre boutique, vous pouvez rouvrir la boutique pour recevoir des commandes.',
    chooseStoreTip: 'Choisissez la plateforme de votre magasin',
    addStoreTip: 'Entrez UNIQUEMENT ',
    addStoreTip2: 'votre-domaine-par-défaut ',
    shopifyTips: 'Connectez-vous à votre administrateur Shopify pour trouver votre domaine par défaut.',
    shopifyTips1: 'www.Votre-domaine-par-défaut.myshopify.com',
    shoplazzaTips: 'Connectez-vous à votre administrateur Shopline pour trouver votre domaine par défaut.',
    shoplazzaTips1: 'www.Votre-domaine-par-defaut.shopline.com',
    shoplineTips: 'Connectez-vous à votre administrateur Shopline pour trouver votre domaine par défaut.',
    shoplineTips1: 'www.Your-Default-Domain.shopline.com',
    eg: 'par exemple. ',
    addStoreVideoTip: 'Comment connecter un nouveau magasin'
  },
  // 店铺设置
  storeSetting: {
    storeStting: 'Réglage du magasin',
    storeName: 'Nom du magasin',
    whetherToAuthorize: "S'il faut autoriser",
    storeLink: 'Lien de magasin',
    taxRuleTitle: 'Rendre le produit taxable',
    taxRuleTip: 'Indique si une taxe sera facturée ou non lorsque la variante du produit est vendue.',
    productRules: 'Règles du produit',
    productRuleTip: "Choisissez une action lorsque l'inventaire de l'article connecté à la référence de votre magasin change",
    dontDealWidth: 'Ne traitez pas',
    productRuleY: "Mettre à jour l'inventaire SKU du magasin automatiquement",
    priceRules: 'Règles de prix',
    storeCurrency: 'devise',
    compareAtPrice: 'Comparer au prix',
    price: 'Prix',
    originalPrice: 'Prix suggéré',
    multiplier: 'Multiplicatrice',
    shipping: 'Frais de port',
    orderRules: 'Règles de commande',
    orderRulesTip1: 'Lorsque le fournisseur de livraison des commandes du magasin livre les marchandises, veuillez sélectionner une action.',
    orderRulesY: 'Télécharger automatiquement le numéro de commande logistique dans la boutique',
    orderRulesTip2: "Lorsque votre boutique reçoit une nouvelle commande, s'il faut passer automatiquement une commande",
    orderRulesTip2N: 'Pas acheté automatiquement',
    orderRulesTip2Y: 'Acheter automatiquement',
    save: 'enregistrer',
    selectCurrency: 'Choisir la devise',
    productCost: 'Coût du produit'
  },
  // 注册身份
  signupUser: {
    questionTile: 'Comment vous décririez-vous dans le secteur de la mode ?',
    answer1: 'Je suis un vendeur en ligne',
    answer2: 'Je suis un vendeur physique',
    answer3: 'Je suis un vendeur omnicanal',
    answer4: 'je suis un influenceur',
    answer5: 'je suis client',
    answer6: 'Autre'
  },
  // my information
  myInformation: {
    myInformation: 'Mon information'
  }
}

